<template>
  <div
    :id="`boss-categories-${categories.id}-${suffix}`"
    :class="isActive ? 'is-active' : ''"
    class="tabs-panel boss-tabs-panel"
  >
    <ul
      v-if="hasCategory"
      class="boss-jobtype-list"
    >
      <li class="boss-jobtype-item">
        <label class="boss-label pega-input"><input
          v-model="all"
          type="checkbox"
          class="boss-input-check"
          data-test="all-1"
        >すべて選択</label>
      </li>
      <template v-for="(category, index) in categories.children">
        <li
          v-if="isFirstLabelOfCategory(categories, category)"
          :key="'li-'+index"
          class="boss-jobtype-item"
        >
          <label
            style="margin-bottom: 5px;color: white;background-color: lightslategray;"
            class="boss-label"
            data-test="label"
          >{{ category.label }}</label>
        </li>
        <select-modal-contents-category
          :key="'select-modal-contents-category-'+index"
          :category="category"
          :category-data-map="categoriesDataMap[category.id]"
          :experience-range-options="experienceRangeOptions"
          :default-experience-id="defaultExperienceId"
          @update-category="updateCategories"
        />
      </template>
    </ul>
    <ul
      v-else
      class="boss-jobtype-list"
    >
      <li class="boss-jobtype-item">
        <label class="boss-label pega-input"><input
          v-model="all"
          type="checkbox"
          class="boss-input-check"
          data-test="all-2"
        >すべて選択</label>
      </li>
      <select-modal-contents-category-item
        v-for="(categoryItem, index) in categories.children"
        :key="index"
        :category-item="categoryItem"
        :category-item-data-map="categoriesDataMap[categoryItem.id]"
        @update-category-item="updateCategories"
      />
    </ul>
  </div>
</template>

<script>
import SelectModalContentsCategoryItem from '@/components/molecules/SelectModalContentsCategoryItem'
import SelectModalContentsCategory from '@/components/molecules/SelectModalContentsCategory'

export default {
  components: {
    SelectModalContentsCategoryItem,
    SelectModalContentsCategory
  },
  props: {
    suffix: {
      type: String,
      required: true
    },
    categories: {
      type: Object,
      default: () => ({})
    },
    categoriesDataMap: {
      type: Object,
      default: () => ({})
    },
    depth: {
      type: Number,
      required: true
    },
    experienceRangeOptions: {
      type: Array,
      default: () => ([])
    },
    defaultExperienceId: {
      type: String,
      default: ''
    },
    isActive: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    hasCategory () {
      return this.depth > 2
    },
    all: {
      get () {
        if (this.hasCategory) {
          return this.categories.children.every(c => c.children.every(j => this.categoriesDataMap[c.id][j.id].check))
        } else {
          return this.categories.children.every(j => this.categoriesDataMap[j.id].check)
        }
      },
      set (value) {
        if (this.hasCategory) {
          const data = this.categories.children.reduce((acc, c) => ({
            ...acc,
            [c.id]: c.children.reduce((acc, j) => ({ ...acc, [j.id]: { ...this.categoriesDataMap[c.id][j.id], check: value } }), {})
          }), {})
          this.$emit('update-categories', { id: this.categories.id, value: data })
        } else {
          const data = this.categories.children.reduce((acc, j) => ({ ...acc, [j.id]: { ...this.categoriesDataMap[j.id], check: value } }), {})
          this.$emit('update-categories', { id: this.categories.id, value: data })
        }
      }
    }
  },
  methods: {
    updateCategories (data) {
      this.$emit('update-categories', { id: this.categories.id, value: { ...this.categoriesDataMap, [data.id]: data.value } })
    },
    isFirstLabelOfCategory (categories, category) {
      if (typeof category.label === 'undefined') return false
      return categories.children.find(x => x.label === category.label).id === category.id
    }
  }
}
</script>
